import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da21ctdv7gurs51ef3cg";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("idle");
    setFormError("");

    const form = e.currentTarget;
    const formData = new FormData(form);

    // 反垃圾 honeypot 校验
    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot !== "") {
      setStatus("success");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    const email = String(formData.get("email") || "").trim();
    if (!email) {
      setStatus("error");
      setFormError("请填写你的邮箱地址。");
      return;
    }

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => payload.append(key, String(value)));

      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload.toString(),
      });

      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText;

      const isSpam = /spam/i.test(serverMsg || "");

      if (!res.ok || !parsed || parsed.code !== "OK" || isSpam) {
        setStatus("error");
        setFormError(
          serverMsg && serverMsg !== ""
            ? serverMsg
            : "提交失败，请稍后再试。",
        );
        return;
      }

      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="w-full bg-background-50 pb-14 md:pb-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-primary-600 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/40" />
          <div className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-accent-500/30" />
          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl text-background-50 md:text-4xl">
                每周精选，第一时间送达
              </h2>
              <p className="mt-3 text-sm text-background-50/90 md:text-base">
                订阅奇妙漫画网资讯，不错过任何一篇脑洞短篇与新作更新。零打扰，只看好故事。
              </p>
            </div>
            <div>
              <form
                id="qm-subscribe-form"
                data-readdy-form="true"
                onSubmit={onSubmit}
                className="flex flex-col gap-3 sm:flex-row"
              >
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱地址"
                  className="h-12 flex-1 rounded-full border border-background-50/30 bg-background-50 px-5 text-sm text-foreground-950 outline-none placeholder:text-foreground-500 focus:ring-2 focus:ring-accent-300"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="website-alt-trap"
                />
                <button
                  type="submit"
                  className="h-12 whitespace-nowrap rounded-full bg-background-50 px-7 text-sm font-bold text-primary-700 transition-colors hover:bg-accent-100"
                >
                  立即订阅
                </button>
              </form>
              {status === "success" && (
                <p className="mt-3 text-sm text-background-50">
                  <i className="ri-checkbox-circle-fill mr-1" />
                  订阅成功，感谢你的关注！
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 text-sm text-secondary-200">
                  <i className="ri-error-warning-fill mr-1" />
                  {formError}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}